import { Pipe, PipeTransform } from "@angular/core";
import { IPredictionCheckResult } from "../interfaces/predict.interface";

@Pipe({ name: "predictionTooltip" })
export class PredictionTooltipPipe implements PipeTransform {
  /**
   * Determines the tooltip translation key for a prediction eligibility check.
   * @param check Prediction eligibility check result
   * @return Translation key describing why prediction is unavailable, or an empty string
   */
  transform(check: IPredictionCheckResult): string {
    if (check.prediction) return "metadataPage.prediction.alreadyPredict";
    if (check.missing?.length) return "metadataPage.prediction.missingData";
    return "";
  }
}

/** Non-gene entries the backend can report as missing for a prediction; any other entry is a gene name */
const MISSING_DATA_FIELDS = ["personal metadata", "tumor data", "treatment data", "patho_stage", "msi_status"];

@Pipe({ name: "predictionMissingData" })
export class PredictionMissingDataPipe implements PipeTransform {
  /**
   * Determines what to display for a data entry missing for a prediction.
   * @param missing Entry reported as missing by the prediction eligibility check
   * @return Translation key for a known data field, or the gene name itself
   */
  transform(missing: string): string {
    if (MISSING_DATA_FIELDS.includes(missing)) return `metadataPage.prediction.missingData.${missing}`;
    return missing;
  }
}
